import { useEffect, useState } from 'react';
import { isNil } from 'lodash';
import { areConfigsEqual } from './config';

export default function useOverlayConfig(initialConfig, dependencies = [], dependenciesMap = _ => (isNil(_) ? {} : _)) {
  const [config, setConfig] = useState({
    ...initialConfig,
    ...dependenciesMap(...dependencies)
  });

  useEffect(() => {
    const nextConfig = {
      ...config,
      ...dependenciesMap(...dependencies)
    };

    if (!areConfigsEqual(config, nextConfig)) {
      setConfig(nextConfig);
    }
  }, [config, ...dependencies]);

  return config;
}
